module.exports = "/images/avatar-s-25.jpg?eb6156c0ec9c829985c1b0a6e1ff2bc1";